// @flow
export const isLocalhost = () => {
    const { hostname } = window.location
	return hostname === "localhost";
};

// eslint-disable-next-line require-jsdoc
export function getDeployment() {
    if (!isLocalhost()) {
        return window.location.hostname.split('.')[0];
    }
    return 'testing';
}



// WEBPACK FOOTER //
// ./src/utils/deployment.js